import React from 'react';
import { Helix2000Character } from '../../../../shared/CharacterTypes';
import { isFeatureEnabled } from './DevTools.config';

import { PlayerAppearance } from './Player/PlayerAppearance';
import { PlayerStats } from './Player/PlayerStats';
import { PlayerActions } from './Player/PlayerActions';
import { TeleportControls } from './Player/TeleportControls';
import { DebugToggles } from './Player/DebugToggles';
import { CheatToggles } from './Player/CheatToggles';
import { CharacterAdmin } from './Player/CharacterAdmin';

interface PlayerToolsTabProps {
    player: Helix2000Character;
    onAction: (action: string, data?: any) => void;
}

export const PlayerToolsTab: React.FC<PlayerToolsTabProps> = ({ player, onAction }) => {
  return (
    <>
      {isFeatureEnabled('player', 'changeColor') && (
        <PlayerAppearance onAction={onAction} />
      )}
      
      <PlayerStats player={player} />
      
      {(isFeatureEnabled('player', 'healButton') || 
        isFeatureEnabled('player', 'levelUpButton') || 
        isFeatureEnabled('player', 'addXpButton')) && (
        <PlayerActions onAction={onAction} />
      )}
      
      {isFeatureEnabled('player', 'teleport') && (
        <TeleportControls onAction={onAction} />
      )}

      {/*
        Note: Spawning section removed from Player Tools and consolidated into NPCToolsTab
        as requested for decomposition cleanup.
      */}

      {isFeatureEnabled('physics', 'debugVisuals') && (
        <DebugToggles onAction={onAction} />
      )}
      
      {(isFeatureEnabled('player', 'godMode') || 
        isFeatureEnabled('player', 'noClip') || 
        isFeatureEnabled('player', 'infiniteMana')) && (
        <CheatToggles onAction={onAction} />
      )}
      
      {(isFeatureEnabled('player', 'addGold') || 
        isFeatureEnabled('player', 'resetStats')) && (
        <CharacterAdmin onAction={onAction} />
      )}
    </>
  );
};
